<div class="widget-container" #StatusCodeDiv>
  <!-- Headings -->
  <main >
    <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: #fff;">
      <div>

        <icon-chart 
          [headerConfig]="item.config.widget_header_config" 
          [fullscreen]="isFullscreen"
          [data]="apiDataStatus" 
          [iconList]="iconList" 
          [expand]="fs" 
          [pageKey]="pageKey" 
          [item]="widgets"
          [apiKey]="100180" 
          [heading]="heading" 
          chartName="statusCodesUI" 
        ></icon-chart>

      </div>

      <div *ngIf="loader" style="height: 200px;">
          <loading ></loading>
      </div>

      <div style="height: 200px; width: auto; " *ngIf="!loader && rowData.length==0">
          <span class="bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
      </div>

      <br>
      <!-- Grid -->
      <div>
          <ag-grid-angular 
            #statusGrid 
            style="width: 100%;" 
            [style.display]="(rowData?.length==0 || error_name) ? 'none' : 'block'"
            class="ag-theme-alpine status_codes"
            [columnDefs]="columnDefs" 
            [defaultColDef]="defaultColDef" 
            [autoGroupColumnDef]="autoGroupColumnDef"
            [pivotHeaderHeight]="0" 
            [rowData]="rowData" 
            (gridReady)="onGridReady($event)" 
            [rowHeight]="35"
            [suppressRowTransform]="true" 
            (firstDataRendered)="onFirstDataRendered($event)"
          ></ag-grid-angular>
        </div>
    </article>
  </main>
</div>